import { securitySections } from "../../../content/legal";
import { PolicySectionList } from "../../legal/PolicySectionList";
import { PageTemplate } from "../../templates/PageTemplate";

export function SecurityPage() {
  return (
    <PageTemplate
      id="security-page"
      header={{
        kicker: "Security",
        title: "Current security posture",
        description:
          "This page describes current engineering controls and disclosure guidance for the product as it exists in this repository.",
      }}
    >
      <PolicySectionList sections={securitySections} />
    </PageTemplate>
  );
}
